import { Container, Main, LeftColumn, RightColumn } from './ReportLayout';

export const ReportLayout = {
  Container: Container,
  Main: Main,
  LeftColumn: LeftColumn,
  RightColumn: RightColumn,
};
